export const setRtfContent = (rtfEditor, string) => {
    try {
        const { _, state: rtfContent } = JSON.parse(string);
        rtfEditor.setData(rtfContent);
    } catch (error) {
        const rtfContent = `{"root":{"children":[{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":"${string}","type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1,"textFormat":0,"textStyle":""}],"direction":"ltr","format":"","indent":0,"type":"root","version":1}}`;
        rtfEditor.setData(rtfContent);
    }
};

export const isEmptyRtfContent = (rtfEditor) => {
    if (!rtfEditor) {
        return true;
    }

    const { plainText, _ } = rtfEditor.getData();
    return !plainText || plainText === "";
};

export const isStringLengthValid = (string, maxLength) => {
    const encoder = new TextEncoder();
    return encoder.encode(string).length <= maxLength;
};
